import Anthropic from "@anthropic-ai/sdk";

const anthropic = new Anthropic({
  apiKey: process.env.REACT_APP_ANTHROPIC_API_KEY,
  dangerouslyAllowBrowser: true
});

export async function analyzeStyleFromImage(imageBase64) {
  // Extract the base64 data and media type from the data URL
  const [mediaInfo, base64Data] = imageBase64.split(',');
  const mediaType = mediaInfo.match(/data:(image\/\w+);base64/)[1];

  const response = await anthropic.messages.create({
    model: "claude-sonnet-4-20250514",
    max_tokens: 20000,
    temperature: 1,
    system: "You are an expert stylist. You use your knowledge to give style recommendations based on body composition, complexion, age. I will upload an image of a person and you recommend style advice based on those things. The output should cover those topics and be framed in the voice of a stylist. Your recommendations should include: ideal color palettes based on their skin tone, flattering silhouettes and fits based on their body shape, style suggestions tailored to their age and likely lifestyle, guidance on what to emphasize or avoid, and tips for casual, professional, and elevated occasions. Be constructive, warm, and fashion-forward in your tone.",
    messages: [
      {
        role: "user",
        content: [
          {
            type: "image",
            source: {
              type: "base64",
              media_type: mediaType,
              data: base64Data
            }
          }
        ]
      }
    ]
  });

  return response.content[0].text;
}